import React, { useEffect, useState } from 'react'
import GradientButton from 'components/Button/GradientButton'
import OutlineButton from 'components/Button/OutlineButton'

const ActivityTab = props => {
  const { filterKey, setFilterKey } = props
  // const [filterList, setFilterList] = useState([
  //   { id: 0, label: 'All Filter', search: '' },
  //   { id: 1, label: 'Auction Started', search: 'AuctionStarted' },
  //   { id: 2, label: 'Auction Cancelled', search: 'AuctionCancelled' },
  //   { id: 3, label: 'Listing Added', search: 'ListingAdded' },
  //   { id: 4, label: 'Listing Cancelled', search: 'ListingCancelled' },
  //   { id: 5, label: 'Offer Made', search: 'OfferMade' },
  //   { id: 6, label: 'Offer Cancelled', search: 'OfferCancelled' },
  //   { id: 7, label: 'Purchased', search: 'Purchased' },
  //   { id: 8, label: 'Auction Won', search: 'AuctionWon' },
  //   { id: 9, label: 'Bid Placed', search: 'BidPlaced' },
  // ])

  return (
    <div className="flex gap-[12px] overflow-x-scroll">
      <div className="min-w-[66px]">
        {filterKey === '' || filterKey === null ? (
          <GradientButton
            label="All"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={66}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="All"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={66}
            height={43}
            onClick={() => {
              setFilterKey('')
            }}
          />
        )}
      </div>

      <div className="min-w-[74px]">
        {filterKey === 'List' ? (
          <GradientButton
            label="List"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={74}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="List"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={74}
            height={43}
            onClick={() => {
              setFilterKey('List')
            }}
          />
        )}
      </div>

      <div className="min-w-[76px]">
        {filterKey === 'Buy' ? (
          <GradientButton
            label="Buy"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={76}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Buy"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={76}
            height={43}
            onClick={() => {
              setFilterKey('Buy')
            }}
          />
        )}
      </div>

      <div className="min-w-[90px]">
        {filterKey === 'Delist' ? (
          <GradientButton
            label="Delist"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={90}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Delist"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={90}
            height={43}
            onClick={() => {
              setFilterKey('Delist')
            }}
          />
        )}
      </div>

      <div className="min-w-[72px]">
        {filterKey === 'Bid' ? (
          <GradientButton
            label="Bid"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={72}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Bid"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={72}
            height={43}
            onClick={() => {
              setFilterKey('Bid')
            }}
          />
        )}
      </div>

      <div className="min-w-[84px]">
        {filterKey === 'Offer' ? (
          <GradientButton
            label="Offer"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={84}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Offer"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={84}
            height={43}
            onClick={() => {
              setFilterKey('Offer')
            }}
          />
        )}
      </div>
    </div>
  )
}

export default ActivityTab
